import React from 'react';
import TableIcon from '../../assets/Icons/TableIcon.svg?react';
import LimitIcon from '../../assets/Icons/LimitIcon.svg?react';
import MiningIcon from '../../assets/Icons/MiningIcon.svg?react';
import TopPlayersIcon from '../../assets/Icons/TopPlayersIcon.svg?react';
import SupportIcon from '../../assets/Icons/SupportIcon.svg?react';
import V2Layout from '../components/V2Layout';
import useV2Auth from '../hooks/useV2Auth';
import {
  subscriptionPlans,
  subscriptionPromos,
  type SubscriptionPlan,
  type SubscriptionPlanIcon,
} from '../data/demoStats';

const MANAGER_TELEGRAM_URL = 'https://t.me/fishh_support';

const planIcons: Record<SubscriptionPlanIcon, React.ReactNode> = {
  networks: <TableIcon />,
  coin: <MiningIcon />,
  ipoker: <LimitIcon />,
  all: <TopPlayersIcon />,
};

const PlanCard: React.FC<{ plan: SubscriptionPlan }> = ({ plan }) => (
  <article className={`plan-card${plan.featured ? ' plan-card--featured' : ''}`}>
    {plan.featured ? <span className="plan-badge">Популярно</span> : null}
    <div className={`plan-icon plan-icon--${plan.icon}`}>{planIcons[plan.icon]}</div>
    <div className="plan-head">
      <h3>{plan.title}</h3>
      {plan.subtitle ? <p className="plan-subtitle">{plan.subtitle}</p> : null}
    </div>
    <ul className="price-list">
      {plan.tiers.map((tier) => (
        <li
          key={tier.label}
          className={`price-row${tier.highlight ? ' price-row--highlight' : ''}`}
        >
          <span className="price-label">{tier.label}</span>
          <span className="price-value">{tier.price}</span>
        </li>
      ))}
    </ul>
    {plan.details && plan.details.length > 0 ? (
      <div className="plan-details">
        <p className="plan-details__title">UNLIM включает лимиты</p>
        <ul className="plan-details__list">
          {plan.details.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      </div>
    ) : null}
  </article>
);

const V2Subscription: React.FC = () => {
  const { user } = useV2Auth();
  const [compact, setCompact] = React.useState(false);

  return (
    <V2Layout
      activeNav="subscription"
      compact={compact}
      onToggleCompact={() => setCompact((value) => !value)}
      userEmail={user?.email}
      breadcrumbs={
        <p className="breadcrumbs">
          Подписка <span>/</span> <strong>Тарифы</strong>
        </p>
      }
      footerNote="Подписка"
    >
      <section className="player-heading player-heading--page">
        <div>
          <div className="player-title-line">
            <h1>Тарифы</h1>
          </div>
          <p className="profile-description">
            Выберите пакет под свои лимиты и румы <span>·</span> дольше подписка — больше выгода
          </p>
        </div>
      </section>

      <section className="subscription-promos" aria-label="Акции">
        {subscriptionPromos.map((promo) => (
          <article key={promo.id} className={`promo-card promo-card--${promo.tone}`}>
            <span className="promo-card__icon" aria-hidden="true">
              {promo.discount}
            </span>
            <div className="promo-card__body">
              <p className="promo-card__description">{promo.description}</p>
              <div className="promo-card__row">
                <p className="promo-card__title">{promo.title}</p>
                <span className="promo-card__discount">{promo.discount}</span>
              </div>
            </div>
          </article>
        ))}
      </section>

      <section className="history-section">
        <div className="block-heading">
          <h2>Цены на подписку</h2>
          <span className="muted">1 месяц · оплата через менеджера в Telegram</span>
        </div>
        <div className="subscription-plans">
          {subscriptionPlans.map((plan) => (
            <PlanCard key={plan.id} plan={plan} />
          ))}
        </div>
      </section>

      <section className="subscription-cta">
        <span className="subscription-cta__icon" aria-hidden="true">
          <SupportIcon />
        </span>
        <div>
          <h2>Готовы оформить подписку?</h2>
          <p className="body-text">
            Для покупки обращайтесь напрямую к{' '}
            <a href={MANAGER_TELEGRAM_URL} target="_blank" rel="noreferrer">
              менеджеру в Telegram
            </a>
          </p>
        </div>
        <a className="acid-button" href={MANAGER_TELEGRAM_URL} target="_blank" rel="noreferrer">
          Написать менеджеру <span aria-hidden="true">↗</span>
        </a>
      </section>

      <aside className="subscription-note">
        <p className="body-text">
          <strong>Важно:</strong> подписка на PS — для тех, кто катает и делится своими руками. Кто
          присылает базы на PS, получает доступ на PS бесплатно. Также действует 25% скидка на любую
          подписку вне акционных предложений.
        </p>
      </aside>
    </V2Layout>
  );
};

export default V2Subscription;
